var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_205)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.17937 26.4625C6.31677 26.4625 5.53764 26.1703 4.95329 25.6138C4.22981 24.946 3.88198 23.9025 4.02111 22.8033L4.52198 18.2816C4.61937 17.4468 5.14807 16.3199 5.74633 15.7077L17.1689 3.61725C20.0211 0.598122 22.9846 0.514645 26.0176 3.35291C29.0368 6.21899 29.1202 9.18247 26.2681 12.2155L14.8455 24.306C14.2472 24.9181 13.1759 25.5025 12.3133 25.6416L7.8472 26.4207C7.61068 26.4346 7.38807 26.4625 7.17937 26.4625ZM21.6211 3.35291C20.5498 3.35291 19.6315 4.02073 18.6855 5.00856L7.26285 17.1268C6.97068 17.419 6.65068 18.1146 6.59503 18.5181L6.09416 23.012C6.02459 23.4712 6.14981 23.8468 6.38633 24.0833C6.63677 24.3338 7.01242 24.4033 7.48546 24.3477L11.9515 23.5825C12.3689 23.499 13.0368 23.1512 13.3011 22.859L24.7237 10.7686C26.4489 8.91812 27.0889 7.23465 24.5707 4.86943C23.4576 3.78421 22.4837 3.35291 21.6211 3.35291Z",
    fill: "#1F0A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5824 14.525C23.5685 14.525 23.5268 14.525 23.4989 14.525C19.1441 14.0937 15.652 10.8102 14.9841 6.48326C14.9007 5.91283 15.2902 5.38413 15.8746 5.30065C16.445 5.21717 16.9598 5.59283 17.0572 6.16326C17.5998 9.53022 20.3268 12.118 23.7076 12.452C24.2781 12.5215 24.6955 13.0224 24.6398 13.5928C24.5702 14.1215 24.1111 14.525 23.5824 14.525Z",
    fill: "#1F0A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6883 30.9566H3.6448C3.07436 30.9566 2.60132 30.4835 2.60132 29.9131C2.60132 29.3288 3.07436 28.8696 3.6448 28.8696H28.6883C29.2448 28.8696 29.7318 29.3288 29.7318 29.9131C29.7318 30.4835 29.2448 30.9566 28.6883 30.9566Z",
    fill: "#1F0A35"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.8234cf13f4d146c6949ee540ba31fce2.svg";
export { ForwardRef as ReactComponent };